export default class NavigateMiniProgramManager {
  constructor() {
    this._show = false;
  }

  set show(show) {
    this._show = show;
  }

  get show() {
    return this._show;
  }
}
